/* ============================================================
   ALPINGARAGET — BINDING POPUP JAVASCRIPT
   File: assets/binding-popup.js
   ============================================================ */

(function () {
  'use strict';

  const COLLECTION_HANDLES = {
    alpin:    'alpinbindningar',
    hybrid:   'hybridbindningar',
    toppturs: 'topptursbindningar',
    junior:   'juniorbindningar',
    telemark: 'telemarksbindningar',
    race:     'racebindningar',
  };

  const CATEGORY_LABELS = {
    recommended: 'Rekommenderad bindning',
    alpin:       'Alpinbindningar',
    hybrid:      'Hybridbindningar',
    toppturs:    'Topptursbindningar',
    junior:      'Juniorbindningar',
    telemark:    'Telemarksbindningar',
    race:        'Racebindningar',
  };

  const CATEGORY_SINGULAR = {
    recommended: 'Rekommenderad bindning',
    alpin:       'Alpinbindning',
    hybrid:      'Hybridbindning',
    toppturs:    'Topptursbindning',
    junior:      'Juniorbindning',
    telemark:    'Telemarksbindning',
    race:        'Racebindning',
  };

  const PRODUCTS_PER_COLLECTION = 50;
  const PAGE_SIZE = 12;

  document.addEventListener('DOMContentLoaded', function () {

    const wrapper = document.getElementById('binding-popup-wrapper');
    if (!wrapper) return;

    /* --------------------------------------------------------
       STATE
    -------------------------------------------------------- */
    let allBindings      = [];
    let activeFilter     = 'all';
    let selectedBinding  = null;
    let confirmedBinding = null;
    let fetchCache       = {};
    let currentPage      = 1;
    let hasRecommended   = false;

    let skiVariantId = wrapper.dataset.skiVariant;
    let skiProductId = wrapper.dataset.skiProductId;
    let skiTitle     = wrapper.dataset.skiTitle || 'Skidor';

    /* --------------------------------------------------------
       ELEMENTS
    -------------------------------------------------------- */
    const emptyState   = document.getElementById('bp-empty-state');
    const chosenState  = document.getElementById('bp-chosen-state');
    const openBtn      = document.getElementById('bp-open-modal');
    const changeBtn    = document.getElementById('bp-change-binding');
    const removeBtn    = document.getElementById('bp-remove-binding');
    const chosenCat    = document.getElementById('bp-chosen-cat');
    const chosenName   = document.getElementById('bp-chosen-name');
    const chosenPrice  = document.getElementById('bp-chosen-price');
    const chosenOld    = document.getElementById('bp-chosen-old');
    const chosenImg    = document.getElementById('bp-chosen-img');
    const successBar   = document.getElementById('bp-success-bar');
    const successText  = document.getElementById('bp-success-text');
    const modalOverlay = document.getElementById('bp-modal-overlay');
    const modalClose   = document.getElementById('bp-modal-close');
    const filterRow    = document.getElementById('bp-filter-row');
    const resultCount  = document.getElementById('bp-result-count');
    const bindingGrid  = document.getElementById('bp-binding-grid');
    const selectedInfo = document.getElementById('bp-selected-info');
    const confirmBtn   = document.getElementById('bp-confirm-binding');

    /* --------------------------------------------------------
       HELPERS
    -------------------------------------------------------- */
    function formatPrice(cents) {
      return (cents / 100).toLocaleString('sv-SE', { minimumFractionDigits: 0 }) + ' kr';
    }
    function showEl(el) { if (el) el.style.display = ''; }
    function hideEl(el) { if (el) el.style.display = 'none'; }
    function showSuccess(msg) {
      successText.textContent = msg;
      showEl(successBar);
      setTimeout(() => hideEl(successBar), 5000);
    }

    function productToBinding(p, category) {
      return {
        id:         p.variants[0].id,
        variantId:  p.variants[0].id,
        productId:  p.id,
        name:       p.title,
        price:      p.variants[0].price,
        compareAt:  p.variants[0].compare_at_price || null,
        image:      p.images[0]
          ? (p.images[0].src || p.images[0])
          : (p.featured_image || null),
        categories: [category],
      };
    }

    /* --------------------------------------------------------
       MOUNTING FIELDS
       Initial hide is handled by CSS in binding-popup.liquid:
         .product-info__block.custom-option { display: none; }
       JS only needs to toggle them when binding is confirmed.
    -------------------------------------------------------- */
    function toggleMountingFields() {
      document.body.classList.toggle('bp-binding-confirmed', !!confirmedBinding);
      document.querySelectorAll('.product-info__block.custom-option').forEach(el => {
        el.style.setProperty('display', confirmedBinding ? 'block' : 'none', 'important');
      });
    }

    /* --------------------------------------------------------
       FETCH RECOMMENDED BINDINGS
    -------------------------------------------------------- */
    async function fetchRecommended() {
      if (!skiProductId) return [];
      try {
        const res  = await fetch(`/recommendations/products.json?product_id=${skiProductId}&intent=complementary&limit=20`);
        if (!res.ok) return [];
        const data = await res.json();
        return (data.products || []).map(p => productToBinding(p, 'recommended'));
      } catch (e) {
        console.warn('Binding popup: could not fetch recommendations', e);
        return [];
      }
    }

    /* --------------------------------------------------------
       FETCH COLLECTIONS
    -------------------------------------------------------- */
    async function fetchCollection(handle) {
      if (fetchCache[handle]) return fetchCache[handle];
      try {
        const res  = await fetch(`/collections/${handle}/products.json?limit=${PRODUCTS_PER_COLLECTION}`);
        if (!res.ok) return [];
        const data = await res.json();
        const products = (data.products || []).map(p => ({
          id:        p.variants[0].id,
          variantId: p.variants[0].id,
          productId: p.id,
          name:      p.title,
          price:     Math.round(parseFloat(p.variants[0].price) * 100),
          compareAt: p.variants[0].compare_at_price
            ? Math.round(parseFloat(p.variants[0].compare_at_price) * 100)
            : null,
          image:     p.images[0] ? p.images[0].src : null,
        }));
        fetchCache[handle] = products;
        return products;
      } catch (e) {
        console.warn('Binding popup: fetch failed', handle, e);
        return [];
      }
    }

    async function fetchAllBindings() {
      bindingGrid.innerHTML = '<p class="bp-no-results">Laddar bindningar…</p>';

      const [recommended, ...collectionResults] = await Promise.all([
        fetchRecommended(),
        ...Object.entries(COLLECTION_HANDLES).map(async ([key, handle]) => {
          const products = await fetchCollection(handle);
          return products.map(p => ({ ...p, categories: [key] }));
        })
      ]);

      hasRecommended = recommended.length > 0;

      const byId = new Map();

      recommended.forEach(p => {
        byId.set(p.productId, { ...p });
      });

      collectionResults.flat().forEach(p => {
        if (byId.has(p.productId)) {
          const existing = byId.get(p.productId);
          p.categories.forEach(cat => {
            if (!existing.categories.includes(cat)) {
              existing.categories.push(cat);
            }
          });
        } else {
          byId.set(p.productId, { ...p });
        }
      });

      allBindings = Array.from(byId.values());

      if (hasRecommended && activeFilter === 'all') {
        activeFilter = 'recommended';
      }

      renderFilters();
      renderGrid();
    }

    /* --------------------------------------------------------
       RENDER FILTERS
    -------------------------------------------------------- */
    function renderFilters() {
      const filters = [
        { key: 'all', label: 'Alla' },
        ...(hasRecommended ? [{ key: 'recommended', label: 'Rekommenderad bindning' }] : []),
        ...Object.entries(COLLECTION_HANDLES).map(([k]) => ({
          key:   k,
          label: CATEGORY_LABELS[k],
        }))
      ];

      filterRow.innerHTML = filters.map(f => `
        <button
          type="button"
          class="bp-filter-btn${activeFilter === f.key ? ' active' : ''}${f.key === 'recommended' ? ' bp-filter-btn--recommended' : ''}"
          data-filter="${f.key}"
          aria-pressed="${activeFilter === f.key}"
        >${f.key === 'recommended' ? '★ ' : ''}${f.label}</button>
      `).join('');

      filterRow.querySelectorAll('.bp-filter-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          activeFilter = btn.dataset.filter;
          currentPage = 1;
          if (
            selectedBinding &&
            activeFilter !== 'all' &&
            !selectedBinding.categories.includes(activeFilter)
          ) {
            selectedBinding = null;
            updateFooter();
          }
          renderFilters();
          renderGrid();
        });
      });
    }

    /* --------------------------------------------------------
       FILTER
    -------------------------------------------------------- */
    function getFiltered() {
      return activeFilter === 'all'
        ? allBindings
        : allBindings.filter(b => b.categories.includes(activeFilter));
    }

    /* --------------------------------------------------------
       RENDER GRID WITH PAGINATION
    -------------------------------------------------------- */
    function renderGrid() {
      const filtered   = getFiltered();
      const totalPages = Math.ceil(filtered.length / PAGE_SIZE);

      if (currentPage < 1) currentPage = 1;
      if (currentPage > totalPages) currentPage = totalPages || 1;

      const start = (currentPage - 1) * PAGE_SIZE;
      const paged = filtered.slice(start, start + PAGE_SIZE);

      resultCount.textContent = `${filtered.length} bindning${filtered.length !== 1 ? 'ar' : ''} visas`;

      if (!filtered.length) {
        bindingGrid.innerHTML = '<p class="bp-no-results">Inga bindningar hittades.</p>';
        renderPagination(0, 0);
        return;
      }

      bindingGrid.innerHTML = paged.map(b => {
        const isSelected    = selectedBinding && selectedBinding.id === b.id;
        const isRecommended = b.categories.includes('recommended');
        const imgHtml = b.image
          ? `<img src="${b.image}" alt="${b.name}" loading="lazy" />`
          : `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>`;
        return `
          <div class="bp-card${isSelected ? ' selected' : ''}" data-id="${b.id}" role="button" tabindex="0" aria-pressed="${isSelected}" aria-label="Välj ${b.name}">
            <div class="bp-card-img">${imgHtml}</div>
            <div class="bp-card-detail">
              <p class="bp-card-name">${b.name}</p>
              <div class="bp-card-prices">
                <span class="bp-card-price">${formatPrice(b.price)}</span>
                ${b.compareAt ? `<span class="bp-card-old">${formatPrice(b.compareAt)}</span>` : ''}
              </div>
              ${isRecommended && activeFilter !== 'recommended' ? '<span class="bp-card-badge">Rekommenderad</span>' : ''}
            </div>
          </div>`;
      }).join('');

      bindingGrid.querySelectorAll('.bp-card').forEach(card => {
        const handler = () => {
          const id = parseInt(card.dataset.id, 10);
          selectedBinding = allBindings.find(b => b.id === id) || null;
          renderGrid();
          updateFooter();
        };
        card.addEventListener('click', handler);
        card.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handler(); }
        });
      });

      renderPagination(currentPage, totalPages);
    }

    /* --------------------------------------------------------
       RENDER PAGINATION
    -------------------------------------------------------- */
    function renderPagination(page, totalPages) {
      const existing = document.getElementById('bp-pagination');
      if (existing) existing.remove();
      if (totalPages <= 1) return;

      const nav = document.createElement('div');
      nav.id = 'bp-pagination';
      nav.className = 'bp-pagination';
      nav.setAttribute('role', 'navigation');
      nav.setAttribute('aria-label', 'Sidnavigering');

      const prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'bp-page-btn';
      prevBtn.innerHTML = '&#8592;';
      prevBtn.disabled = page <= 1;
      prevBtn.setAttribute('aria-label', 'Föregående sida');
      prevBtn.addEventListener('click', () => {
        currentPage--;
        bindingGrid.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        renderGrid();
      });

      const pageInfo = document.createElement('span');
      pageInfo.className = 'bp-page-info';
      pageInfo.textContent = `${page} / ${totalPages}`;

      const nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'bp-page-btn';
      nextBtn.innerHTML = '&#8594;';
      nextBtn.disabled = page >= totalPages;
      nextBtn.setAttribute('aria-label', 'Nästa sida');
      nextBtn.addEventListener('click', () => {
        currentPage++;
        bindingGrid.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        renderGrid();
      });

      nav.appendChild(prevBtn);
      nav.appendChild(pageInfo);
      nav.appendChild(nextBtn);

      bindingGrid.parentNode.insertBefore(nav, bindingGrid.nextSibling);
    }

    function updateFooter() {
      if (selectedBinding) {
        selectedInfo.textContent = `Vald: ${selectedBinding.name} — ${formatPrice(selectedBinding.price)}`;
        confirmBtn.disabled = false;
      } else {
        selectedInfo.textContent = 'Välj en bindning ovan';
        confirmBtn.disabled = true;
      }
    }

    /* --------------------------------------------------------
       MODAL OPEN / CLOSE
    -------------------------------------------------------- */
    function openModal() {
      selectedBinding = confirmedBinding;
      currentPage = 1;
      if (modalOverlay.parentNode !== document.body) {
        document.body.appendChild(modalOverlay);
      }
      showEl(modalOverlay);
      document.body.style.overflow = 'hidden';

      if (allBindings.length === 0) {
        fetchAllBindings();
      } else {
        activeFilter = hasRecommended ? 'recommended' : 'all';
        renderFilters();
        renderGrid();
      }
      updateFooter();
      modalClose.focus();
    }

    function closeModal() {
      hideEl(modalOverlay);
      document.body.style.overflow = '';
      openBtn.focus();
    }

    /* --------------------------------------------------------
       CONFIRM BINDING
    -------------------------------------------------------- */
    function confirmBinding() {
      if (!selectedBinding) return;
      confirmedBinding = selectedBinding;

      const labelCat = confirmedBinding.categories.find(c => c !== 'recommended') || 'recommended';
      chosenCat.textContent   = CATEGORY_SINGULAR[labelCat] || '';
      chosenName.textContent  = confirmedBinding.name;
      chosenPrice.textContent = formatPrice(confirmedBinding.price);
      chosenOld.textContent   = confirmedBinding.compareAt ? formatPrice(confirmedBinding.compareAt) : '';
      chosenImg.innerHTML = confirmedBinding.image
        ? `<img src="${confirmedBinding.image}" alt="${confirmedBinding.name}" loading="lazy" style="width:100%;height:100%;object-fit:contain;" />`
        : `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>`;

      hideEl(emptyState);
      showEl(chosenState);
      toggleMountingFields();
      closeModal();
    }

    /* --------------------------------------------------------
       REMOVE BINDING
    -------------------------------------------------------- */
    function removeBinding() {
      confirmedBinding = null;
      selectedBinding  = null;

      showEl(emptyState);
      hideEl(chosenState);
      toggleMountingFields();
    }

    /* --------------------------------------------------------
       REPLACE THE ORIGINAL ADD TO CART BUTTON
    -------------------------------------------------------- */
    const originalBtn = document.querySelector('button[name="add"]');

    if (originalBtn) {
      originalBtn.style.display = 'none';

      const ourBtn = document.createElement('button');
      ourBtn.type        = 'button';
      ourBtn.className   = originalBtn.className;
      ourBtn.textContent = originalBtn.textContent.trim() || 'Lägg i varukorg';
      originalBtn.parentNode.insertBefore(ourBtn, originalBtn.nextSibling);

      ourBtn.addEventListener('click', async function () {
        ourBtn.disabled    = true;
        ourBtn.textContent = 'Lägger till…';

        const properties = {};
        document.querySelectorAll('input[name^="properties"], textarea[name^="properties"]').forEach(el => {
          const key = el.name.replace('properties[', '').replace(']', '');
          if (el.value.trim()) properties[key] = el.value.trim();
        });

        const items = [{ id: String(skiVariantId), quantity: 1, properties }];
        if (confirmedBinding) {
          items.push({ id: String(confirmedBinding.variantId), quantity: 1 });
        }

        try {
          const res = await fetch('/cart/add.js', {
            method:  'POST',
            headers: { 'Content-Type': 'application/json' },
            body:    JSON.stringify({ items }),
          });

          if (!res.ok) {
            const err = await res.json();
            throw new Error(err.description || 'Cart error');
          }

          if (confirmedBinding) {
            showSuccess(`${skiTitle} + ${confirmedBinding.name} tillagda i varukorgen!`);
          }

          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            await cartDrawer.refresh(true);
            cartDrawer.open();
          }

        } catch (e) {
          console.error('Binding popup: add to cart failed', e);
          alert('Något gick fel, försök igen. (' + e.message + ')');
        }

        ourBtn.disabled    = false;
        ourBtn.textContent = originalBtn.textContent.trim() || 'Lägg i varukorg';
      });
    }

    /* --------------------------------------------------------
       TRACK VARIANT CHANGES
    -------------------------------------------------------- */
    document.addEventListener('variant:change', (e) => {
      if (e.detail && e.detail.variant && e.detail.variant.id) {
        skiVariantId = String(e.detail.variant.id);
        wrapper.dataset.skiVariant = skiVariantId;
      }
    });
    document.addEventListener('change', (e) => {
      if (e.target && e.target.name === 'id') skiVariantId = e.target.value;
    });

    /* --------------------------------------------------------
       CLOSE MODAL ON OVERLAY CLICK / ESC
    -------------------------------------------------------- */
    modalOverlay.addEventListener('click', (e) => {
      if (e.target === modalOverlay) closeModal();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modalOverlay.style.display !== 'none') closeModal();
    });

    /* --------------------------------------------------------
       WIRE UP POPUP BUTTONS
    -------------------------------------------------------- */
    openBtn.addEventListener('click',    openModal);
    changeBtn.addEventListener('click',  openModal);
    removeBtn.addEventListener('click',  removeBinding);
    modalClose.addEventListener('click', closeModal);
    confirmBtn.addEventListener('click', confirmBinding);

  });

})();